<template>
    <div>
            <a-button class="top_btn" type="primary" @click="add('')" v-has="'btn_add'"  >
                添加文章
            </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading"  rowKey="id"  :pagination="false" >
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>

            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="add(text.id)" v-has="'btn_edit'">编辑  <a-divider type="vertical"/></a>

          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>

    </div>
</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "标题",
            dataIndex: "title",
            ellipsis: true,
            key: "title",
        },
        {
            title: "应用到",
            dataIndex: "apply_name",
            ellipsis: true,
            key: "apply_name"
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
        },
        {
            title: "状态",
            key: "status",
            width: "150px",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                visibleImg: false,
                tableImg: "",
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/Suggestions"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        methods: {
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            add(id) {
                if (id == '') {
                    this.$router.push('/WebsiteDetection/AddSuggestions')
                } else {
                    this.$router.push(`/WebsiteDetection/EditSuggestions?id=${id}`)
                }

            },
            getList(page) {
                API.service.GET_LIST({page: page || 1, ...this.seach}).then(res => {
                    this.data = res.data.data
                    this.loading = false
                })
            },
        }
    }
</script>

<style scoped>
</style>
